'use strict';

/**
 * @classname QuantitySynchronize
 * @classdesc 数量同期
 */
export default class QuantitySynchronize {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-detail .quantity
	 * @return {undefined}
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('change', () => this.onChange());
	};


	/**
	 * changeイベントのコールバック
	 *
	 * @memberof QuantitySynchronize
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const value = this._$e.val();
		$('.quantity').val(value);
	};
};
